import { usePsfPromoteOrSharePageData } from '#src/app/pages/psf/promoteOrShare/pageContext';

type Result = ModelHookResult<{
	photo?: {
		url: string;
		mobileUrl: string;
	};
}>;

export function usePetitionMedia(): Result {
	const {
		data: {
			petition: { photo },
		},
	} = usePsfPromoteOrSharePageData();

	const photoUrl = !photo?.petitionMedium.processing ? photo?.petitionMedium.url : undefined;
	const photoMobileUrl = !photo?.petitionSmall.processing ? photo?.petitionSmall.url : undefined;

	return {
		data: {
			photo:
				photoUrl && photoMobileUrl
					? {
							url: photoUrl,
							mobileUrl: photoMobileUrl,
						}
					: undefined,
		},
	};
}
